import ExhibitionEventsTable from "./exhibition-events-table";

export default ExhibitionEventsTable;
